import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01357f17"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OAdicionarAtributo p-input-filled" }
const _hoisted_2 = { class: "OAdicionarAtributo__Buttons" }

import { MDropdown } from "@/components/Gerais"
  import { useRouter, useRoute } from "vue-router"
  import { ref, onMounted, computed } from "vue"
  import AtributosRepositorio from "@/repositorios/atributos/atributos.repositorio"
  import { AtributoBase, ParamsAtributo } from "@/repositorios/atributos/atributos.modelos"
  import { useToast } from "primevue/usetoast"
  import { ToastSeverity } from "primevue/api"
  import { AtributoStore } from "@/store/atributos/atributo/atributo.store"
  import { storeToRefs } from "pinia"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import { usarBuscarMaisDados} from "@/composable/UsarBuscarMaisDados/usarBuscarMaisDados"
  import { EntidadeGenerica } from "@/types/gerais"
  import { useI18n } from "vue-i18n"

  interface Props {
    aguardandoAlgumaReq: boolean
    parametros?: ParamsAtributo 
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OAdicionarAtributo',
  props: {
    aguardandoAlgumaReq: { type: Boolean },
    parametros: null
  },
  setup(__props: any) {

const props = __props as {
    aguardandoAlgumaReq: boolean
    parametros?: ParamsAtributo 
  }

  

  const { t } = useI18n()

  const atributoSelecionado = ref<AtributoBase>()
  const router = useRouter()
  const route = useRoute()
  const { leitor } = usarLeitorDeDados()
  const {
    buscarMaisDados,
    atualizarDadosDoRepositorio,
    filtrarDadosDoRepositorio
  } = usarBuscarMaisDados()

  const toast = useToast()

  const atributosRepositorio = new AtributosRepositorio()

  const atributos = ref<EntidadeGenerica[]>([])

  const { adicionarAtributo } = AtributoStore()
  const { listaAtributos } = storeToRefs(AtributoStore())

  const lerAtributos = leitor<AtributoBase, ParamsAtributo>(
    atributosRepositorio.listarAtributos, {
      tipo_do_atributo: "igual.capacidade",
      "por-pagina": 30,
    }
  )

  const exibirTooltip = computed(() => {
    return botaoDesativado.value
      ? t("precisarSelecionarUmAtributoPrimeiro")
      : null
  })

  const estaCarregandoAtributos = computed(() => {
    return lerAtributos.resultado.status === 'pendente'
  })

  const botaoDesativado = computed(() => {
    return !atributoSelecionado.value
  })

  const direcionarParaNovoAtributo = (): void => {
    const currentPath = route?.path
    router.push(currentPath + "/criar-atributos")
  }

  const adicionarAtributoNaLista = (atributo?: AtributoBase): void => {
    if (!atributo) {
      toast.add({
        severity: ToastSeverity.WARN,
        summary: t("issoNaoPode"),
        detail: t("primeiroVocePrecisaEscolherUmAtributo"),
        life: 3000,
      })
      return
    }

    const jaExisteNaLista = listaAtributos.value.some(
      (atr) => atr.id === atributo.id
    )

    if (jaExisteNaLista) {
      toast.add({
        severity: ToastSeverity.INFO,
        summary: t("duplicado"),
        detail: t("esseAtributoJaFoiAdicionadoNaLista"),
        life: 3000,
      })
      return
    }
    adicionarAtributo(atributo)
  }

  const buscarMaisAtributos = async (): Promise<void> => {
    await buscarMaisDados(lerAtributos, atributos)
  }

  const listarAtributos = async (): Promise<void> => {
    lerAtributos.sobrescreverParametros({
      ...props.parametros
    })
    
    await lerAtributos.executar()

    if (lerAtributos.resultado.status === "sucesso") {
      await atualizarDadosDoRepositorio(lerAtributos, atributos)
    }
  }

  const filtrarAtributos = async (valorInserido: string): Promise<void> => {
    await filtrarDadosDoRepositorio(valorInserido, lerAtributos, atributos)
  }

  onMounted(async () => {
    await listarAtributos()
  })

return (_ctx: any,_cache: any) => {
  const _component_PButton = _resolveComponent("PButton")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createVNode(_unref(MDropdown), {
      modelValue: atributoSelecionado.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((atributoSelecionado).value = $event)),
      onOnFiltrandoBusca: filtrarAtributos,
      "buscar-mais-itens": buscarMaisAtributos,
      carregando: _unref(estaCarregandoAtributos),
      class: "OAdicionarAtributo__Dropdown",
      "data-testid": "OAdicionarAtributo__Dropdown",
      desativado: _unref(estaCarregandoAtributos) || __props.aguardandoAlgumaReq,
      "option-label": "nome",
      options: atributos.value,
      placeholder: _unref(t)('atributo'),
      "usar-carregamento-sob-demanda": ""
    }, null, 8, ["modelValue", "carregando", "desativado", "options", "placeholder"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PButton, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (adicionarAtributoNaLista(atributoSelecionado.value))),
        class: _normalizeClass(["OAdicionarAtributo__Button p-button-success", {
          'OAdicionarAtributo__Button--desativado':
            _unref(botaoDesativado) || __props.aguardandoAlgumaReq,
        }]),
        "data-testid": "OAdicionarAtributo__BotaoAdicionar",
        disabled: _unref(botaoDesativado) || __props.aguardandoAlgumaReq,
        label: _unref(t)('adicionarAtributoSelecionado'),
        title: _unref(exibirTooltip)
      }, null, 8, ["class", "disabled", "label", "title"]),
      _createVNode(_component_PButton, {
        onClick: direcionarParaNovoAtributo,
        class: "OAdicionarAtributo__Button p-button-warning",
        "data-testid": "add-new-attribute",
        disabled: __props.aguardandoAlgumaReq,
        label: _unref(t)('criarNovoAtributo')
      }, null, 8, ["disabled", "label"])
    ])
  ]))
}
}

})